import { useNavigate } from "react-router-dom";
import { FaQuestionCircle, FaGlobeAmericas, FaBan, FaInfoCircle } from "react-icons/fa";
import "./ResourcesShared.css";

const Restrictions = () => {
    const navigate = useNavigate();

    return (
        <div className="rs-container">
            <main className="rs-main-content">
                <div className="rs-container-1200">
                    <nav className="rs-breadcrumb">
                        <ol>
                            <li><a href="/help">Help Center</a></li>
                            <li><a href="/resources">Resources</a></li>
                            <li>Restrictions</li>
                        </ol>
                    </nav>

                    <article className="rs-article">
                        <header className="rs-article-header">
                            <h1 className="rs-article-title">Are There Any Restricted Countries for Company Incorporation in the USA?</h1>
                            <div className="rs-article-meta">
                                <span>Posted by BooksComply Team</span>
                                <span>•</span>
                                <span>Last updated August 2025</span>
                            </div>
                        </header>
                        
                        <div className="rs-article-content">
                            <div className="rs-intro-card">
                                <FaGlobeAmericas className="rs-intro-icon" />
                                <p>
                                    The United States allows both U.S. residents and non-U.S. residents to incorporate a business. However, due to government regulations and sanctions, individuals and entities from certain countries may be restricted or prohibited from forming a U.S. company.
                                </p>
                            </div>

                            <section className="rs-section">
                                <h2>Countries Restricted from U.S. Company Incorporation</h2>
                                <p>
                                    The U.S. government, through the Office of Foreign Assets Control (OFAC) and other regulatory bodies, restricts business activities with individuals and entities from sanctioned countries. These restrictions typically include:
                                </p>
                                
                                <div className="rs-warning-card">
                                    <div className="rs-warning-icon">
                                        <FaBan />
                                    </div>
                                    <div>
                                        <h3>OFAC-Sanctioned Countries (as of 2024)</h3>
                                        <p>As of the latest updates, the following countries face severe restrictions:</p>
                                        <div className="rs-columns">
                                            <ul>
                                                <li>Cuba 🇨🇺</li>
                                                <li>Iran 🇮🇷</li>
                                                <li>North Korea 🇰🇵</li>
                                                <li>Syria 🇸🇾</li>
                                            </ul>
                                            <ul>
                                                <li>Russia 🇷🇺 <small>(Certain entities & individuals)</small></li>
                                                <li>Belarus 🇧🇾 <small>(Certain entities & individuals)</small></li>
                                                <li>Venezuela 🇻🇪 <small>(Certain government officials & entities)</small></li>
                                                <li>Crimea Region of Ukraine 🇺🇦</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="rs-note">
                                    <FaInfoCircle className="rs-note-icon" />
                                    <div>
                                        <h4>What These Restrictions Mean:</h4>
                                        <ul>
                                            <li>Individuals and businesses from these countries may not be allowed to register a company in the U.S.</li>
                                            <li>Financial transactions, including opening a U.S. bank account or obtaining an EIN, could be restricted.</li>
                                            <li>Sanctions may change, so it is essential to check OFAC's Specially Designated Nationals (SDN) List before proceeding.</li>
                                        </ul>
                                    </div>
                                </div>
                            </section>

                            <section className="rs-section">
                                <h2><FaQuestionCircle className="rs-feature-icon" /> Can You Incorporate If You Are from a Restricted Country?</h2>
                                <div className="rs-info-card">
                                    <ul>
                                        <li>If you are from a restricted country but hold a passport or residency from a permitted country, you may be eligible to incorporate in the U.S.</li>
                                        <li>Some individuals may require special licenses or government approvals to conduct business.</li>
                                        <li>If your country is partially restricted, consult with a legal or tax expert before proceeding.</li>
                                    </ul>
                                </div>
                            </section>
                        </div>
                    </article>
                </div>
            </main>
        </div>
    );
};

export default Restrictions;